export const bytesToGigabytes = (bytes: number) => bytes / 1024 ** 3

// Rounds a number to a specific number of decimal places - use for calculations
export const roundToDecimals = (n: number, decimals: number) => {
  const factor = Math.pow(10, decimals)
  return Math.round(n * factor) / factor
}

// Cuts off a number to a specific number of decimal places (no rounding) - use for display
export const truncateDecimal = (n: number, decimals: number) => {
  const factor = Math.pow(10, decimals)
  return Math.floor(n * factor) / factor
}

// This function takes a file size and its unit (bytes, kilobytes, megabytes, or gigabytes)
// and converts it into a human-readable string format, optionally using binary (base 1024) or decimal (base 1000) units.
export const formatSize = (
  size: number,
  sizeUnit: 'b' | 'kb' | 'mb' | 'gb',
  useBinary: boolean = true
) => {
  const base = useBinary ? 1024 : 1000
  let bytes: number

  switch (sizeUnit) {
    case 'b':
      bytes = size
      break
    case 'kb':
      bytes = size * base
      break
    case 'mb':
      bytes = size * base ** 2
      break
    case 'gb':
      bytes = size * base ** 3
      break
    default:
      throw new Error('Unsupported unit')
  }

  if (bytes >= base ** 4) return `${truncateDecimal(bytes / base ** 4, 2)} TB`

  if (bytes >= base ** 3) return `${truncateDecimal(bytes / base ** 3, 2)} GB`

  const sizeInMB = bytes / base ** 2
  const decimals = sizeInMB > 0 && sizeInMB < 1 ? 2 : 1
  return `${truncateDecimal(sizeInMB, decimals)} MB`
}
